import { useId, useRef, useEffect } from "react";
import styles from "./CheckBox.module.css";

export default function Checkbox({
  name,
  label,
  checked,
  onChange,
  disabled = false,
}) {
  const id = useId();
  const ref = useRef(null);

  return (
    <label
      className={styles.wrapper}
      htmlFor={id}
      data-disabled={disabled || undefined}
    >
      <input
        name={name}
        id={id}
        ref={ref}
        type="checkbox"
        className={styles.input}
        checked={checked}
        onChange={onChange}
      />
      <span aria-hidden="true" className={styles.box} />
    </label>
  );
}
